import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { faChartSimple, faExternalLink, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ChartConfiguration, ChartData } from 'chart.js';
import { CockpitChartService } from 'src/app/page/cockpit/cockpit-page/components/cockpit-chart/service/cockpit-chart.service';
import { CockpitFilter, cockpitChartInterface } from 'src/app/util/interfaces/cockpitRework/cockpitRework';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CockpitPageService } from './service/cockpit-page.service';
import { CockpitEditService } from '../cockpit-edit/service/cockpit-edit.service';
import { FilterHeaderComponent } from 'src/app/page/cockpit/cockpit-page/components/filter-header/filter-header.component';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-cockpit-page',
	templateUrl: './cockpit-page.component.html',
	styleUrls: ['./cockpit-page.component.scss'],
})
export class CockpitPageComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild(FilterHeaderComponent) cockpitHeader: FilterHeaderComponent;

	labels: LabelsInterface = {
		lbl_edocs_carregando: 'Loading',
		lbl_ckp_gerenciar_ckp: 'Manage my cockpit',
		lbl_cockpit_reload_page: '',
		lbl_geral_nenhum: '',
		lbl_geral_selecione: 'Select',
		lbl_geral_minuto: 'min',
		lbl_escalonamento_minutos: 'min',
		lbl_escalonamento_hora: 'hour',
		lbl_ckp_sem_indicadores_va_gerenciamento: '',
		lbl_geral_exibir_valores: 'Show Values',
	};

	reloadPageTime = null;

	constructor(
		private CockpitPageService: CockpitPageService,
		private CockpitEditService: CockpitEditService,
		private CockpitChartService: CockpitChartService,
		private LabelsService: LabelsService,
		public Router: Router
	) {}

	isLoadingLabels = true;
	isLoadingCockpitCharts = true;
	isLoadingCustomCockpitCharts = true;
	isLoading = true;
	showChartValues = true;

	cockpitCards: cockpitChartInterface[] = [];
	cockpitCharts: cockpitChartInterface[] = [];
	cockpitCustomCards: cockpitChartInterface[] = [];
	cockpitCustomCharts: cockpitChartInterface[] = [];
	allCockpitCharts: any[] = [];

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		const savedShowChartValues = localStorage.getItem('showChartValues');
		if (savedShowChartValues !== null) {
			this.showChartValues = savedShowChartValues === 'true';
		}

		this.setConfigDefinition();
		this.loadFiltersFromCache();

		this.getCockpitCharts();
		this.getCustomCockpitCharts();

		this.setReloadTimer();
	}

	ngAfterViewInit(): void {
		// Aplica os filtros do cache ao componente header após a view estar pronta
		setTimeout(() => {
			const cachedFilters = localStorage.getItem('cockpitFilters');
			if (cachedFilters && this.cockpitHeader) {
				try {
					const filters = JSON.parse(cachedFilters);

					if (filters.period_type) {
						this.cockpitHeader.selectedValues.period_type = filters.period_type;
					}
					if (filters.show_mine !== undefined) {
						this.cockpitHeader.selectedValues.show_mine = filters.show_mine;
					}
					if (filters.location !== undefined) {
						this.cockpitHeader.selectedValues.location = filters.location;
					}

					if (filters.ciType !== undefined && filters.ciType !== '') {
						this.cockpitHeader.selectedCiItem = {
							ciType: filters.ciType.toString(),
							subType: filters.subType || '',
							type: filters.type || '',
						};
					}

					if (filters.startDate) {
						this.cockpitHeader.startDate = filters.startDate;
					}

					if (filters.endDate) {
						this.cockpitHeader.endDate = filters.endDate;
					}
				} catch (error) {
					console.error('Erro ao aplicar filtros do cache ao header:', error);
				}
			}
		});
	}

	loadFiltersFromCache(): void {
		const cachedFilters = localStorage.getItem('cockpitFilters');
		if (cachedFilters) {
			try {
				const filters = JSON.parse(cachedFilters);

				if (filters.period_type === 'custom' && filters.startDate && filters.endDate) {
					localStorage.setItem(
						'customDate',
						JSON.stringify({
							startDate: filters.startDate,
							endDate: filters.endDate,
						})
					);
				}
			} catch (error) {
				console.error('Erro ao carregar filtros do cache:', error);
			}
		}
	}

	ngOnDestroy(): void {
		if (this.reloadPageTime) {
			clearInterval(this.reloadPageTime);
		}
	}

	mergeIndicatorsWithCharts(charts: any[], isCustom: boolean = false): any[] {
		if (!this.cockpitHeader?.indicators?.indicators || this.cockpitHeader.indicators.indicators.length === 0) {
			return charts;
		}

		return charts.map((chart) => {
			const matchingIndicator = this.cockpitHeader.indicators.indicators.find(
				(indicator) => indicator.name === chart.title && chart.custom === isCustom
			);

			if (matchingIndicator && matchingIndicator.values && matchingIndicator.values.length > 0) {
				return {
					...chart,
					chartData: {
						datasets: [
							{
								data: matchingIndicator.values[0].data,
								backgroundColor: chart.chartData?.datasets[0]?.backgroundColor || [],
								borderColor: chart.chartData?.datasets[0]?.borderColor || [],
								pointBackgroundColor: chart.chartData?.datasets[0]?.pointBackgroundColor || [],
								pointBorderColor: chart.chartData?.datasets[0]?.pointBorderColor || [],
								label: chart.chartData?.datasets[0]?.label || '',
								hoverBackgroundColor: chart.chartData?.datasets[0]?.hoverBackgroundColor || [],
							},
						],
						labels: matchingIndicator.values[0].labels,
					},
				};
			}

			return chart;
		});
	}

	private updateAllCockpitCharts(): void {
		this.allCockpitCharts = [...(this.cockpitCharts || []), ...(this.cockpitCustomCharts || [])];
	}

	setConfigDefinition(): void {
		if (!['0', '1', '2', '3'].includes(localStorage.getItem('ckpL'))) {
			localStorage.setItem('ckpL', '0');
		}

		if (isNaN(Number.parseInt(localStorage.getItem('cockpitReloadTime')))) {
			localStorage.setItem('cockpitReloadTime', '300000');
		}
	}

	getCockpitCharts(): void {
		if (localStorage.getItem('customDate')) {
			const storedCustomDate = JSON.parse(localStorage.getItem('customDate'));

			this.CockpitChartService.getCockpit('', storedCustomDate.startDate, storedCustomDate.endDate)
				.subscribe(
					(charts) => {
						charts = this.mergeIndicatorsWithCharts(charts);
						const cockpitCharts = [];
						const cockpitCards = [];

						if (charts && charts.length > 0) {
							for (const chart of charts) {
								chart.type === 'text' ? cockpitCards.push(chart) : cockpitCharts.push(chart);
							}
						}

						this.cockpitCharts = cockpitCharts;
						this.cockpitCards = cockpitCards;
						let ckpO = localStorage.getItem('ckpO');
						ckpO = JSON.parse(localStorage.getItem('ckpO'));

						if (ckpO?.length > 0) {
							const newOrderCockpitCharts = [];
							for (const [index, cockpitItemId] of (<any>ckpO).entries()) {
								if (cockpitCharts && cockpitCharts.length > 0) {
									for (const item of this.cockpitCharts) {
										if (item.id === cockpitItemId) {
											newOrderCockpitCharts.splice(index, 0, item);
										} else if (!(<any>ckpO).includes(item.id)) {
											newOrderCockpitCharts.push(item);
											(<any>ckpO).push(item.id);
										}
									}
								}
							}
							this.cockpitCharts = newOrderCockpitCharts;
							localStorage.setItem('ckpO', JSON.stringify(ckpO));
						} else {
							const cockpitOrder = [];
							if (cockpitCharts && cockpitCharts.length > 0) {
								for (const item of this.cockpitCharts) {
									cockpitOrder.push(item.id);
								}
							}
							localStorage.setItem('ckpO', JSON.stringify(cockpitOrder));
						}

						this.isLoadingCockpitCharts = false;
					},
					() => {
						this.CockpitEditService.restartCockpit().subscribe(() => {
							localStorage.setItem('ckpO', '[]');

							this.isLoadingCockpitCharts = false;
						});
					}
				)
				.add(() => {
					this.updateAllCockpitCharts();
					this.applyFilter();
				});
		} else {
			this.CockpitChartService.getCockpit()
				.subscribe(
					(charts) => {
						charts = this.mergeIndicatorsWithCharts(charts);
						const cockpitCharts = [];
						const cockpitCards = [];

						if (charts && charts.length > 0) {
							for (const chart of charts) {
								chart.type === 'text' ? cockpitCards.push(chart) : cockpitCharts.push(chart);
							}
						}

						this.cockpitCharts = cockpitCharts;
						this.cockpitCards = cockpitCards;
						let ckpO = localStorage.getItem('ckpO');
						ckpO = JSON.parse(localStorage.getItem('ckpO'));

						if (ckpO?.length > 0) {
							const newOrderCockpitCharts = [];
							for (const [index, cockpitItemId] of (<any>ckpO).entries()) {
								if (cockpitCharts && cockpitCharts.length > 0) {
									for (const item of this.cockpitCharts) {
										if (item.id === cockpitItemId) {
											newOrderCockpitCharts.splice(index, 0, item);
										} else if (!(<any>ckpO).includes(item.id)) {
											newOrderCockpitCharts.push(item);
											(<any>ckpO).push(item.id);
										}
									}
								}
							}
							this.cockpitCharts = newOrderCockpitCharts;
							localStorage.setItem('ckpO', JSON.stringify(ckpO));
						} else {
							const cockpitOrder = [];
							if (cockpitCharts && cockpitCharts.length > 0) {
								for (const item of this.cockpitCharts) {
									cockpitOrder.push(item.id);
								}
							}
							localStorage.setItem('ckpO', JSON.stringify(cockpitOrder));
						}

						this.isLoadingCockpitCharts = false;
					},
					() => {
						this.CockpitEditService.restartCockpit().subscribe(() => {
							localStorage.setItem('ckpO', '[]');
							this.isLoadingCockpitCharts = false;
						});
					}
				)
				.add(() => {
					this.updateAllCockpitCharts();
					this.applyFilter();
				});
		}
	}

	getCustomCockpitCharts(): void {
		if (localStorage.getItem('customDate')) {
			const storedCustomDate = JSON.parse(localStorage.getItem('customDate'));

			this.CockpitChartService.getCockpit('custom', storedCustomDate.startDate, storedCustomDate.endDate)
				.subscribe((charts) => {
					charts = this.mergeIndicatorsWithCharts(charts, true);

					const cockpitCustomCharts = [];
					const cockpitCustomCards = [];

					if (charts && charts.length > 0) {
						for (const chart of charts) {
							chart.type === 'text' ? cockpitCustomCards.push(chart) : cockpitCustomCharts.push(chart);
						}
					}

					this.cockpitCustomCharts = cockpitCustomCharts;
					this.cockpitCustomCards = cockpitCustomCards;
					let ckpC = localStorage.getItem('ckpC');
					ckpC = JSON.parse(localStorage.getItem('ckpC'));

					if (ckpC?.length > 0) {
						const newOrderCockpitCharts = [];
						for (const [index, cockpitItemId] of (<any>ckpC).entries()) {
							if (cockpitCustomCharts && cockpitCustomCharts.length > 0) {
								for (const item of this.cockpitCustomCharts) {
									if (item.id === cockpitItemId) {
										newOrderCockpitCharts.splice(index, 0, item);
									}
								}
							}
						}
						this.cockpitCustomCharts = newOrderCockpitCharts;
					} else {
						const cockpitOrder = [];
						if (cockpitCustomCharts && cockpitCustomCharts.length > 0) {
							for (const item of this.cockpitCustomCharts) {
								cockpitOrder.push(item.id);
							}
						}
						localStorage.setItem('ckpC', JSON.stringify(cockpitOrder));
					}

					this.isLoadingCustomCockpitCharts = false;
				})
				.add(() => {
					this.updateAllCockpitCharts();
					this.applyFilter();
				});
		} else {
			this.CockpitChartService.getCockpit('custom')
				.subscribe((charts) => {
					charts = this.mergeIndicatorsWithCharts(charts, true);
					const cockpitCustomCharts = [];
					const cockpitCustomCards = [];

					if (charts && charts.length > 0) {
						for (const chart of charts) {
							chart.type === 'text' ? cockpitCustomCards.push(chart) : cockpitCustomCharts.push(chart);
						}
					}

					this.cockpitCustomCharts = cockpitCustomCharts;
					this.cockpitCustomCards = cockpitCustomCards;
					let ckpC = localStorage.getItem('ckpC');
					ckpC = JSON.parse(localStorage.getItem('ckpC'));

					if (ckpC?.length > 0) {
						const newOrderCockpitCharts = [];
						for (const [index, cockpitItemId] of (<any>ckpC).entries()) {
							if (cockpitCustomCharts && cockpitCustomCharts.length > 0) {
								for (const item of this.cockpitCustomCharts) {
									if (item.id === cockpitItemId) {
										newOrderCockpitCharts.splice(index, 0, item);
									}
								}
							}
						}
						this.cockpitCustomCharts = newOrderCockpitCharts;
					} else {
						const cockpitOrder = [];
						if (cockpitCustomCharts && cockpitCustomCharts.length > 0) {
							for (const item of this.cockpitCustomCharts) {
								cockpitOrder.push(item.id);
							}
						}
						localStorage.setItem('ckpC', JSON.stringify(cockpitOrder));
					}

					this.isLoadingCustomCockpitCharts = false;
				})
				.add(() => {
					this.updateAllCockpitCharts();
					this.applyFilter();
				});
		}
	}

	setReloadTimer() {
		let timer = 0;
		try {
			timer = Number.parseInt(localStorage.getItem('cockpitReloadTime'));
			if (isNaN(timer)) {
				localStorage.setItem('cockpitReloadTime', '86400000');
				timer = 86_400_000;
			}
		} catch {
			timer = 86_400_000;
		}

		this.reloadPageTime = setInterval(() => {
			this.getCockpitCharts();
		}, timer);
	}

	applyFilter(): void {
		this.CockpitChartService.getSelectedFilters().subscribe((filters: CockpitFilter[]) => {
			if (filters.length > 0 && filters[0].indicatorFamily && filters[0].indicatorFamily.length > 0) {
				const hideItemsByFamily = (items: any[], family: string) => {
					return items.filter((item) => item.family !== family);
				};

				for (const family of filters[0].indicatorFamily) {
					this.cockpitCards = hideItemsByFamily(this.cockpitCards, family);
					this.cockpitCharts = hideItemsByFamily(this.cockpitCharts, family);
					this.cockpitCustomCards = hideItemsByFamily(this.cockpitCustomCards, family);
					this.cockpitCustomCharts = hideItemsByFamily(this.cockpitCustomCharts, family);
				}
			}
		});
	}

	onFilterChange(filterValues?: any): void {
		this.isLoadingCockpitCharts = true;
		this.isLoadingCustomCockpitCharts = true;

		// Preserva as configurações individuais dos charts antes de recarregar
		const cockpitIndividualConfigs = localStorage.getItem('cockpitIndividualConfigs');

		if (filterValues) {
			const cockpitFilters = {
				period_type: filterValues.period_type,
				startDate: filterValues.startDate,
				endDate: filterValues.endDate,
				show_mine: filterValues.show_mine,
				location: filterValues.location,
				locations: filterValues.locations || [],
				statuses: filterValues.statuses || [],
				ciType: filterValues.ciType || '',
				subType: filterValues.subType || '',
				type: filterValues.type || '',
				ciTypesArray: filterValues.ciTypesArray || [],
			};
			localStorage.setItem('cockpitFilters', JSON.stringify(cockpitFilters));

			if (filterValues.period_type === 'custom' && filterValues.startDate && filterValues.endDate) {
				localStorage.setItem(
					'customDate',
					JSON.stringify({
						startDate: filterValues.startDate,
						endDate: filterValues.endDate,
					})
				);
			} else {
				localStorage.removeItem('customDate');
			}
		}

		// Restaura as configurações para garantir que os componentes foram inicializados
		setTimeout(() => {
			if (cockpitIndividualConfigs) {
				localStorage.setItem('cockpitIndividualConfigs', cockpitIndividualConfigs);
			}
		}, 100);

		// Recarrega os charts
		this.getCockpitCharts();
		this.getCustomCockpitCharts();
	}

	toggleChartValues(value: boolean): void {
		this.showChartValues = value;
		localStorage.setItem('showChartValues', value.toString());
		// Força a atualização dos gráficos
		const temporaryCharts = this.cockpitCharts;
		const temporaryCustomCharts = this.cockpitCustomCharts;
		this.cockpitCharts = [];
		this.cockpitCustomCharts = [];
		setTimeout(() => {
			this.cockpitCharts = temporaryCharts;
			this.cockpitCustomCharts = temporaryCustomCharts;
		}, 1);
	}
}
